import { useEffect, useState } from "react";
import api from "../../../utils/api";
import { useRestaurantConfig } from "../../../utils/restaurantConfig";
import { getRestaurantTodayDate } from "../../../utils/dateTimeUtils";

/**
 * Fetches takeaway order history for a given date + search (debounced),
 * defaulting to today. Used by the Takeaway Order History page.
 */
export const useTakeawayHistory = () => {
  const { timezone } = useRestaurantConfig();

  const [date, setDate] = useState(getRestaurantTodayDate(timezone));
  const [search, setSearch] = useState("");
  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(true);

  const resetToToday = () => setDate(getRestaurantTodayDate(timezone));

  useEffect(() => {
    let cancelled = false;
    const timer = setTimeout(async () => {
      setLoading(true);
      try {
        const params = new URLSearchParams({ orderType: "takeaway" });
        if (date) params.set("date", date);
        if (search.trim()) params.set("search", search.trim());

        const res = await api.get(`/orders/history?${params.toString()}`);
        if (!cancelled) setOrders(res.data || []);
      } catch (err) {
        console.error("Failed to load takeaway order history", err);
        if (!cancelled) setOrders([]);
      } finally {
        if (!cancelled) setLoading(false);
      }
    }, 300); // debounce search keystrokes

    return () => {
      cancelled = true;
      clearTimeout(timer);
    };
  }, [date, search]);

  return { date, setDate, search, setSearch, orders, loading, resetToToday };
};
